module.exports = __webpack_public_path__ + "static/img/passket.ee55365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passket.png
// module id = oAFx
// module chunks = 0